if (!customElements.get('sey-faq-item')) {
  customElements.define(
    'sey-faq-item',
    class SeyFaqItem extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.sey-collection-faq__answer');
        if (!this.details || !this.summary || !this.panel || this.initialized) return;

        this.initialized = true;
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        this.summary.addEventListener('click', this.onSummaryClick, true);
        this.panel.addEventListener('transitionend', this.onTransitionEnd);

        this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        if (this.details.open) {
          this.classList.add('is-open');
          this.panel.style.height = 'auto';
        }
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onSummaryClick, true);
        this.panel?.removeEventListener('transitionend', this.onTransitionEnd);
        this.initialized = false;
      }

      get reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onSummaryClick(event) {
        event.preventDefault();
        if (this.classList.contains('is-open')) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        this.details.open = true;
        this.classList.add('is-open');
        this.summary.setAttribute('aria-expanded', 'true');

        if (this.reduceMotion) {
          this.panel.style.height = 'auto';
          return;
        }

        const startHeight = this.panel.getBoundingClientRect().height;
        this.panel.style.height = `${startHeight}px`;
        this.panel.offsetHeight;
        this.panel.style.height = `${this.panel.scrollHeight}px`;
      }

      collapse() {
        this.classList.remove('is-open');
        this.summary.setAttribute('aria-expanded', 'false');

        if (this.reduceMotion) {
          this.details.open = false;
          this.panel.style.height = '';
          return;
        }

        this.panel.style.height = `${this.panel.scrollHeight}px`;
        this.panel.offsetHeight;
        this.panel.style.height = '0px';
      }

      onTransitionEnd(event) {
        if (event.target !== this.panel || event.propertyName !== 'height') return;

        if (this.classList.contains('is-open')) {
          this.panel.style.height = 'auto';
        } else {
          this.details.open = false;
          this.panel.style.height = '';
        }
      }
    }
  );
}
